import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from '../locales/en/translation.json';
import ptTranslations from '../locales/pt/translation.json';
import esTranslations from '../locales/es/translation.json';

// Simplified config: Keep all translations in the default 'translation' namespace
// This allows using keys like t('app.common.noData') directly without namespace splitting
const resources = {
  en: {
    translation: enTranslations,
  },
  pt: {
    translation: ptTranslations,
  },
  es: {
    translation: esTranslations,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: import.meta.env.VITE_FALLBACK_LOCALE || 'en', // Force default language
    fallbackLng: import.meta.env.VITE_FALLBACK_LOCALE || 'en',
    debug: import.meta.env.DEV && import.meta.env.VITE_ENABLE_CONSOLE_LOGS === 'true',

    // Use single default namespace for simplicity
    ns: ['translation'],
    defaultNS: 'translation',
    fallbackNS: 'translation',
    returnObjects: true,

    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'querystring', 'navigator'],
      caches: ['localStorage'],
    },
    // Add a missing key handler for a better development experience.
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: (lng, ns, key) => {
      // Missing keys will be handled silently
    },
  });

export default i18n;
